import token, { tokenToVars } from '../token';
import Input from './input';

export { Input };
export default tokenToVars(Input, token);
